export { default as AngrySmiley } from './AngrySmiley'
export { default as GoodSmiley } from './GoodSmiley'
export { default as StraightFace } from './StraightFace'
export { default as Smiley } from './Smiley'

